function SignOutPopup() {
  return (
    <div className="flex flex-col items-center">
      <h2 className="text-lg">Sign Out?</h2>
    </div>
  );
}

export default SignOutPopup;
